import { useCallback, useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useDispatch, useSelector } from "react-redux";
import { actions, selectors } from "redux-store";
import { useTypedTranslations } from "hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      overflow: "visible",
    },
    dialogAvatar: {
      width: 100,
      height: 100,
      backgroundColor: theme.palette.primary.main,
      margin: "-50px auto 0 auto",
    },
    dialogIcon: {
      width: 70,
      height: 70,
    },
  }),
);

const useCreateMerchantDialog = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(
    () => ({
      dialog: {
        paper: styles.dialog,
      },
    }),
    [styles],
  );
  const atomicStyles = useAtomicStyles();
  const isOpen = useSelector(selectors.getIsCreateMerchantDialogOpen);
  const [t] = useTypedTranslations();
  const dispatch = useDispatch();

  const onClose = useCallback(() => {
    dispatch(actions.setIsCreateMerchantDialogOpen(false));
  }, [dispatch]);

  return {
    styles,
    classes,
    atomicStyles,
    isOpen,
    onClose,
    t,
  };
};

export { useCreateMerchantDialog as default };
